import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("staff") !== null && localStorage.getItem("staff") !== undefined && localStorage.getItem("staff") !== "") {

    data = JSON.parse(localStorage.getItem("staff"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        getstaff: (state, action) => {
            localStorage.setItem("staff", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
          
        },

    },

})

export const {getstaff } = Insider.actions;
export default Insider.reducer;